module.exports = __webpack_public_path__ + "themes/mf/img/multiplier-x2.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/multiplier-x2.png
// module id = 82
// module chunks = 3